import React from 'react'
import PropTypes from 'prop-types'
import { Collapse } from 'react-bootstrap'
import CategoryHeaderSimGolf from './category_header_sim_golf'
import LeaguesTableContainerSimGolf from '../../containers/sim_golf/leagues_table_container_sim_golf'

const CategoryComponentSimGolf = (
  {
    id,
    name,
    opened,
    color,
    specialStatus,
    isFree,
    leagueIds,
    toggleCategory,
    addLeaguesWithPagination,
    openPopup,
    deleteCategory,
    userIsCustomerManager,
    leaguesCount,
    loadingData,
    categories,
    updateCategoriesSimGolf,
    updateURL,
  }) => {
  const handleScroll = (e) => {
    const currentScrollAmount = Math.round(e.target.scrollHeight - e.target.scrollTop)
    const currentScrollPosition =
      currentScrollAmount <= e.target.clientHeight
        ? e.target.clientHeight
        : currentScrollAmount
    const marginError = e.target.clientHeight / 100
    const bottom = currentScrollPosition >= (e.target.clientHeight - marginError) && currentScrollPosition <= (e.target.clientHeight + marginError)

    if (bottom) {
      addLeaguesWithPagination()
    }
  }

  return (
    <div className='item_list_sim_golf'>
      <CategoryHeaderSimGolf
        id={ id }
        name={ name }
        loadingData={ loadingData }
        leaguesCount={ leaguesCount }
        opened={ opened }
        color={ color }
        isFree={ isFree }
        specialStatus={ specialStatus }
        userIsCustomerManager={ userIsCustomerManager }
        onClick={ toggleCategory }
        openPopup={ openPopup }
        deleteCategory={ deleteCategory }
        categories={ categories }
        updateCategoriesSimGolf={ updateCategoriesSimGolf }
        updateURL={ updateURL }
      />
      <Collapse in={ opened }>
        <div onScroll={ handleScroll }>
          <LeaguesTableContainerSimGolf
            leagueIds={ leagueIds }
            categoryId={ id }
            categoryColor={ color }
          />
        </div>
      </Collapse>
    </div>
  )
}

CategoryComponentSimGolf.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  loadingData: PropTypes.bool,
  opened: PropTypes.bool.isRequired,
  color: PropTypes.string.isRequired,
  specialStatus: PropTypes.string,
  isFree: PropTypes.bool,
  leagueIds: PropTypes.array.isRequired,
  userIsCustomerManager: PropTypes.bool.isRequired,
  toggleCategory: PropTypes.func.isRequired,
  addLeaguesWithPagination: PropTypes.func.isRequired,
  openPopup: PropTypes.func.isRequired,
  deleteCategory: PropTypes.func.isRequired,
  updateCategoriesSimGolf: PropTypes.func.isRequired,
  leaguesCount: PropTypes.number,
  categories: PropTypes.object.isRequired,
  updateURL: PropTypes.string,
}

export default CategoryComponentSimGolf